import { useState, useEffect, useCallback } from "react";
import { fetchBusinessRolesWithPermissions } from "../api/fetchBusinessRolesWithPermissions";
import { BusinessRoleWithPermissions } from "../api/fetchBusinessRolesWithPermissions/types";

export function useBusinessRolesWithPermissions() {
  const [roles, setRoles] = useState<BusinessRoleWithPermissions[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadRoles = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchBusinessRolesWithPermissions();
      setRoles(response.roles);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to load business roles",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadRoles();
  }, [loadRoles]);

  return {
    roles,
    loading,
    error,
    refetch: loadRoles,
  };
}
